export default __webpack_public_path__ + "static/media/WireIconBW.274f291d.svg";